





































import {CodebookModel, ProductModel} from '@/libs/Api';
import {Component, Vue} from 'vue-property-decorator';
import {CrudAction} from '@/libs/core/crud/crud-action';
import {createCrudQueryPayload} from '@/libs/core/crud/crud-query';
import {CrudGetter} from '@/libs/core/crud/crud-getter';
import CrudTable from '@/libs/common/components/CrudTable.vue';
import {Constants} from '@/libs/constants/constants';
import {codebooksStore} from '@/libs/codebooks/+state/store';
import {productsStore} from '@/libs/products/+state/store';

@Component({
	computed: {
		Constants() {
			return Constants
		}
	},
    components: {
        CrudTable
    }
})
export default class ProductNremEGeneral extends Vue {

	firstLoad = true;

	get pending(): boolean {
		const pending = codebooksStore.useGetter(CrudGetter.Pending);
		if (!pending) {
			this.firstLoad = false;
		}
		return pending;
	}

	get codebooks(): any {
		return codebooksStore.useGetter(CrudGetter.Data);
	}

	get product(): ProductModel {
		const product = {...productsStore.useGetter(CrudGetter.Detail, Constants.NremEProductId)} as ProductModel;
		if (product.isHidden == null) {
			product.isHidden = false;
		}
		return product;
	}

	get savingProduct(): boolean {
		return productsStore.useGetter(CrudGetter.Saving, Constants.NremEProductId);
	}

	mounted() {
		this.getCodebooks();
		this.getProduct();
	}

	getProduct() {
		productsStore.dispatch(CrudAction.Get, { id: Constants.NremEProductId, key: Constants.NremEProductId });
	}

	saveProduct() {
		productsStore.dispatch(CrudAction.Update, { item: this.product, key: Constants.NremEProductId });
	}

	getCodebooks() {
		codebooksStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CodebookModel>({
			field: 'name',
			order: 'asc'
		}));
	}
    
}
